module.exports = __webpack_public_path__ + "../resources/images/illustration_to_me-2e1d78a746d82ff8e78f0f8f84cede5d.svg";